export * from "./DeviceDetectHelper";